import React from 'react';
import cn from 'classnames';
import { HMGroupLogoIcon, CosLogoIcon, WeekdayLogoIcon, ArketLogoIcon, OtherstoriesLogoIcon, AfoundLogoIcon, } from "../../../ui/Icon";
import styles from './RewardSummary.module.scss';
const brands = {
    cos: CosLogoIcon,
    weekday: WeekdayLogoIcon,
    otherStories: OtherstoriesLogoIcon,
    hmHome: HMGroupLogoIcon,
    arket: ArketLogoIcon,
    afound: AfoundLogoIcon,
};
const RewardSummaryBrandLogo = ({ brand, brandColor }) => {
    const TagName = brands[brand] || HMGroupLogoIcon;
    return (React.createElement("div", null,
        React.createElement(TagName, { role: "img", className: cn(brandColor === 'black' ? styles.iconColorDefault : styles.iconColorReverse) })));
};
export default RewardSummaryBrandLogo;
//# sourceMappingURL=RewardSummaryBrandLogo.js.map